  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.hover-expand-grid__container');
    if (!container) return;

    const items = container.querySelectorAll('.hover-expand-grid__item');
    const blocksCount = items.length;

    function setActiveItem(activeIndex, items, blocksCount) {
      let gridTemplateColumns;

      if (blocksCount === 1) {
        gridTemplateColumns = '100%';
      } else if (blocksCount === 2) {
        if (activeIndex === 0) {
          gridTemplateColumns = '70% 30%';
        } else {
          gridTemplateColumns = '30% 70%';
        }
      } else if (blocksCount === 3) {
        if (activeIndex === 0) {
          gridTemplateColumns = '70% 15% 15%';
        } else if (activeIndex === 1) {
          gridTemplateColumns = '15% 70% 15%';
        } else {
          gridTemplateColumns = '15% 15% 70%';
        }
      } else if (blocksCount >= 4) {
        if (activeIndex === 0) {
          gridTemplateColumns = '70% 10% 10% 10%';
        } else if (activeIndex === 1) {
          gridTemplateColumns = '10% 70% 10% 10%';
        } else if (activeIndex === 2) {
          gridTemplateColumns = '10% 10% 70% 10%';
        } else {
          gridTemplateColumns = '10% 10% 10% 70%';
        }
      }

      container.style.gridTemplateColumns = gridTemplateColumns;

      items.forEach((item, index) => {
        if (index === activeIndex) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    if (window.innerWidth >= 769) {
      setActiveItem(0, items, blocksCount);

      items.forEach((item, index) => {
        item.addEventListener('mouseenter', () => {
          setActiveItem(index, items, blocksCount);
        });
      });

      container.addEventListener('mouseleave', () => {
        const activeItem = container.querySelector('.hover-expand-grid__item.active');
        if (activeItem) {
          const activeIndex = Array.from(items).indexOf(activeItem);
          setActiveItem(activeIndex, items, blocksCount);
        }
      });
    }

    let touchStartTime;
    let touchStartX = 0;
    let touchStartY = 0;

    container.addEventListener(
      'touchstart',
      function (e) {
        touchStartTime = Date.now();
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    container.addEventListener(
      'touchend',
      function (e) {
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const diffX = Math.abs(touchStartX - touchEndX);
        const diffY = Math.abs(touchStartY - touchEndY);

        if (Date.now() - touchStartTime < 500 && diffX < 10 && diffY < 10) {
          const target = document.elementFromPoint(touchEndX, touchEndY);
          const item = target.closest('.hover-expand-grid__item');
          if (item) {
            item.click();
          }
        }
      },
      { passive: true }
    );

    const prevButton = document.querySelector('.hover-expand-grid__mobile-nav--prev');
    const nextButton = document.querySelector('.hover-expand-grid__mobile-nav--next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', function () {
        if (container) {
          container.scrollBy({
            left: -container.offsetWidth * 0.8,
            behavior: 'smooth',
          });
        }
      });

      nextButton.addEventListener('click', function () {
        if (container) {
          container.scrollBy({
            left: container.offsetWidth * 0.8,
            behavior: 'smooth',
          });
        }
      });
    }

    function updateNavButtons() {
      if (!container || !prevButton || !nextButton) return;

      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      prevButton.style.display = scrollLeft > 10 ? 'flex' : 'none';
      nextButton.style.display = scrollLeft < scrollWidth - clientWidth - 10 ? 'flex' : 'none';
    }

    if (container) {
      container.addEventListener('scroll', updateNavButtons);
      updateNavButtons();

      setTimeout(updateNavButtons, 100);
    }

    window.addEventListener('resize', updateNavButtons);
  });